import ChartContainer from '../Services/charts/apex-charts/ChartContainer';
import { useHistogram } from './hooks/useHistogram';

export const Histogram = ({ title, values, subtitles, horizontal , className = '' , color , height = 350}) => {
    const { chartConfig } = useHistogram({
        values,
        subtitles,
        horizontal,
        color
    });

    return (
        <ChartContainer
            title={title}
            options={chartConfig.options}
            series={chartConfig.series}
            type="bar"
            height={height}
            className={`${className}`}
        />
    );
};
